import { createGlobalStyle } from "styled-components";

/**
 * Capa de refresco visual (aprobada 2026-08, acento "Mar" #0E7C86).
 *
 * Va DESPUES de globalStyle en app.js a proposito: misma especificidad, gana la
 * ultima. Todo lo de aqui son estilos; no toca ningun componente ni consulta.
 * Para revertir: quitar el import de app.js.
 */
const Refresh = createGlobalStyle`
  :root{
    --mh-accent:#0E7C86;
    --mh-accent-ink:#FFFFFF;
    --mh-accent-soft:rgba(14,124,134,.10);
    --mh-ring:0 0 0 3px rgba(14,124,134,.22);
    --mh-ink:#18181B;
    --mh-ink-2:#3F3F46;
    --mh-muted:#71717A;
    --mh-line:#E4E4E7;
    --mh-line-soft:#F1F1F3;
    --mh-surface:#FAFAFA;
    --mh-r:8px;
    --mh-shadow:0 1px 2px rgba(24,24,27,.06), 0 12px 28px -14px rgba(24,24,27,.22);
  }

  /* ---------- Tipografia: mas cuerpo (400 se veia anemico) ---------- */
  /* antd fija font-family en 'body' y su CSS se inyecta despues, asi que hace
     falta 'html body' para ganarle. Los componentes de antd heredan, pero se
     listan los mas usados porque algunos declaran la suya. */
  html body,
  html body .ant-table,
  html body .ant-btn,
  html body .ant-input,
  html body .ant-select,
  html body .ant-picker,
  html body .ant-modal,
  html body .ant-menu,
  html body .ant-tag,
  html body .ant-dropdown{
    font-family:'Inter', DMSans, -apple-system, BlinkMacSystemFont, sans-serif;
  }
  html body{
    font-weight:450;
    color:var(--mh-ink);
    -webkit-font-smoothing:antialiased;
  }
  h1,h2,h3,h4,h5{ color:var(--mh-ink); letter-spacing:-.012em; }

  /* ---------- Botones ---------- */
  .ant-btn{
    /* button.style.js fija radius 4px con mas especificidad: se refuerza */
    border-radius:var(--mh-r) !important;
    font-weight:600 !important;
    border-color:var(--mh-line);
    color:var(--mh-ink);
    box-shadow:none;
    transition:background .15s ease, border-color .15s ease, box-shadow .15s ease;
  }
  .ant-btn:hover{ background:var(--mh-line-soft); border-color:#D4D4D8; color:var(--mh-ink); }
  .ant-btn:focus-visible{ outline:none; box-shadow:var(--mh-ring); }
  .ant-btn-primary{
    background:var(--mh-accent) !important; border-color:var(--mh-accent) !important; color:var(--mh-accent-ink) !important;
  }
  .ant-btn-primary:hover,.ant-btn-primary:focus{
    background:#0C6C75; border-color:#0C6C75; color:var(--mh-accent-ink);
  }
  .ant-btn-dangerous,.ant-btn-danger{ color:#B91C1C; border-color:#FECACA; background:#fff; }
  .ant-btn-dangerous:hover,.ant-btn-danger:hover{ background:#FEF2F2; border-color:#FCA5A5; color:#991B1B; }
  .ant-btn-link{ color:var(--mh-accent); font-weight:550; }

  /* ---------- Campos ---------- */
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number,
  .ant-picker,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector{
    border-radius:var(--mh-r) !important;
    border-color:var(--mh-line) !important;
    font-weight:500;
    color:var(--mh-ink);
  }
  .ant-input:hover,.ant-input-affix-wrapper:hover,.ant-picker:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector{ border-color:#D4D4D8; }
  .ant-input:focus,.ant-input-focused,
  .ant-input-affix-wrapper-focused,
  .ant-picker-focused,
  .ant-select-focused:not(.ant-select-disabled) .ant-select-selector{
    border-color:var(--mh-accent) !important;
    box-shadow:var(--mh-ring) !important;
  }
  .ant-input::placeholder,.ant-select-selection-placeholder{ color:var(--mh-muted); }

  /* ---------- Desplegables y menus ---------- */
  .ant-select-dropdown,.ant-dropdown-menu,.ant-picker-panel-container{
    border-radius:10px; box-shadow:var(--mh-shadow); border:1px solid var(--mh-line);
  }
  .ant-select-item{ border-radius:6px; margin:2px 4px; font-weight:500; }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled){
    background:var(--mh-accent-soft); color:var(--mh-ink); font-weight:650;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled){ background:var(--mh-line-soft); }

  /* ---------- Tablas: mas aire y jerarquia ---------- */
  .ant-table{ color:var(--mh-ink-2); }
  .ant-table-thead > tr > th{
    /* AntTables.styles.js pinta la cabecera: se refuerza */
    background:var(--mh-surface) !important;
    color:var(--mh-muted) !important;
    font-weight:650 !important;
    font-size:12px !important;
    letter-spacing:.02em;
    border-bottom:1px solid var(--mh-line) !important;
    padding:10px 12px !important;
  }
  .ant-table-tbody > tr > td{
    padding:12px !important;
    font-weight:500;
    color:var(--mh-ink-2);
    border-bottom:1px solid var(--mh-line-soft) !important;
  }
  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr.ant-table-row:hover > td{ background:var(--mh-surface); }
  /* numeros e importes: monoespaciada y alineados */
  .invoiceListTable .ant-table-tbody > tr > td:nth-child(2){
    font-family:'JetBrains Mono', ui-monospace, monospace;
    font-weight:620; color:var(--mh-ink); font-variant-numeric:tabular-nums; white-space:nowrap;
  }
  .invoiceListTable .ant-table-tbody > tr > td:nth-child(6),
  .invoiceListTable .ant-table-thead > tr > th:nth-child(6){
    font-variant-numeric:tabular-nums; font-weight:680; color:var(--mh-ink);
    white-space:nowrap; text-align:right;
  }
  .invoiceListTable .ant-table-thead > tr > th:nth-child(6){ font-weight:650 !important; color:var(--mh-muted) !important; }

  /* ---------- Checks, radios, switch ---------- */
  .ant-checkbox-inner{ width:17px !important; height:17px !important; border-radius:5px !important; border:1.5px solid #D4D4D8; }
  .ant-checkbox-checked .ant-checkbox-inner{ background:var(--mh-accent) !important; border-color:var(--mh-accent) !important; }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,.ant-checkbox:hover .ant-checkbox-inner{ border-color:var(--mh-accent); }
  .ant-checkbox-checked::after{ border-color:var(--mh-accent); border-radius:5px; }
  .ant-radio-inner{ width:17px; height:17px; border-width:1.5px; }
  .ant-radio-checked .ant-radio-inner{ border-color:var(--mh-accent); }
  .ant-radio-inner::after{ background:var(--mh-accent); }
  .ant-switch-checked{ background:var(--mh-accent); }

  /* ---------- Estados como pildora ---------- */
  .ant-tag{
    border-radius:999px !important; font-weight:620; font-size:12px; padding:1px 10px; border:1px solid transparent;
  }

  /* ---------- Modales ---------- */
  .ant-modal-content{ border-radius:12px !important; overflow:hidden; box-shadow:0 1px 2px rgba(24,24,27,.06), 0 16px 40px -20px rgba(24,24,27,.28); }
  .ant-modal-header{ border-bottom:none; padding:16px 18px 8px; }
  .ant-modal-title{ font-weight:680; color:var(--mh-ink); }
  .ant-modal-body{ padding:0 18px 16px; font-weight:500; color:var(--mh-ink-2); }
  .ant-modal-footer{ border-top:1px solid var(--mh-line-soft); background:var(--mh-surface); padding:12px 18px; }
  .ant-modal-confirm-btns .ant-btn{ font-weight:600; }

  /* ---------- Paginacion y pestanas ---------- */
  .ant-pagination-item,.ant-pagination-prev .ant-pagination-item-link,.ant-pagination-next .ant-pagination-item-link{
    border-radius:8px; border-color:var(--mh-line); font-weight:600;
  }
  .ant-pagination-item-active{ border-color:var(--mh-accent); background:var(--mh-accent-soft); }
  .ant-pagination-item-active a{ color:var(--mh-accent); }
  .ant-tabs-tab{ font-weight:600; color:var(--mh-muted); }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{ color:var(--mh-accent); }
  .ant-tabs-ink-bar{ background:var(--mh-accent); }

  /* ---------- Tarjetas y avisos ---------- */
  .ant-card,.isoBoxWrapper{ border-radius:14px; border-color:var(--mh-line); }
  .ant-notification-notice,.ant-message-notice-content{ border-radius:10px; box-shadow:var(--mh-shadow); font-weight:500; }
  .ant-popover-inner,.ant-tooltip-inner{ border-radius:8px; }

  @media (prefers-reduced-motion: reduce){ .ant-btn{ transition:none; } }
  /* ---------- Pantalla de configuracion VERI*FACTU ---------- */
  .mh-card{
    background:#fff; border:1px solid var(--mh-line); border-radius:14px;
    padding:18px 20px; margin-bottom:16px;
  }
  .mh-card--accent{ border-left:4px solid var(--mh-accent); }
  .mh-card h4{ margin:0 0 6px; font-size:15px; font-weight:700; color:var(--mh-ink); }
  .mh-label{ display:block; font-size:12.5px; font-weight:600; color:var(--mh-muted); margin-bottom:5px; }
  .mh-choice{
    display:flex; gap:12px; align-items:flex-start; padding:14px 16px;
    border:1px solid var(--mh-line); border-radius:10px; cursor:pointer; transition:.15s;
  }
  .mh-choice:hover{ border-color:#D4D4D8; }
  .mh-choice.is-on{ border-color:var(--mh-accent); background:var(--mh-accent-soft); }
  .mh-choice input{ margin-top:3px; accent-color:var(--mh-accent); }
  .mh-choice b{ display:block; font-weight:650; color:var(--mh-ink); }
  .mh-choice em{ display:block; font-style:normal; font-size:13px; color:var(--mh-muted); margin-top:2px; }
  .mh-chain{
    background:var(--mh-surface); border:1px solid var(--mh-line); border-radius:10px;
    padding:12px 14px; font-family:'JetBrains Mono', ui-monospace, monospace;
    font-size:12.5px; color:var(--mh-ink-2); overflow-x:auto; margin:0 0 12px;
  }
  .mh-url{
    display:block; background:var(--mh-surface); border:1px solid var(--mh-line);
    border-radius:8px; padding:10px 12px; font-family:'JetBrains Mono', ui-monospace, monospace;
    font-size:12px; color:var(--mh-ink-2); word-break:break-all;
  }
`;

export default Refresh;
